import { Alert, Badge, Button, Card, Table, Timeline } from "flowbite-react";
import React, { useEffect, useRef, useState } from "react";
import axios from "../../config/axiosInstance";
import { ADMIN, QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import TitleStripe2 from "../common/TitleStripe2";
import CardQueryDescription from "../common/CardQueryDescription";
import SliderToPreview from "../common/SliderToPreview";
import NoOcurrence from "../common/query/NoOcurrence";
import FooterQuery from "./FooterQuery";
import { useQuery } from "react-query";
import DrawerLoading from "../DrawerLoading";
import QueryVehicleInput from "../inputs/QueryVehicleInput";
import moment from "moment";
import {
  IoMdCheckmarkCircleOutline,
  IoMdCloseCircleOutline,
  IoMdOptions,
} from "react-icons/io";
import { MdBlock, MdInfoOutline } from "react-icons/md";
import { FiAlertOctagon } from "react-icons/fi";
import {
  checkIfHasRestrictions,
  formatDocument,
  formatToReal,
  getImageScoreSale,
} from "../../utils/utils";
import { FaCar, FaPrint, FaUser } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useReactToPrint } from "react-to-print";
import PdfViewer from "../common/query/PdfViewer";
import Checklist from "../common/query/Checklist";
import Telefones from "../common/query/Telefones";
import Enderecos from "../common/query/Enderecos";
import Emails from "../common/query/Emails";
import CNDT from "./custom-queries-vehicle/CNDT";
import PrecificadorTabela from "../common/query/PrecificadorTabela";
import CRLV from "./custom-queries-vehicle/CRLV";
import CodigoSegurancaCRV from "./custom-queries-vehicle/CodigoSegurancaCRV";
import FooterLGPD from "../common/query/FooterLGPD";
import TitleStripe from "../common/TitleStripe";

const CustomVehicleQueryReview = ({ query, hasHeaderPDF = "true" }) => {
  const [info, setInfo] = useState("");
  const [isDoneRequest, setIsDoneRequest] = useState(false);
  const [error, setError] = useState("");
  const [errorQuery, setErrorQuery] = useState("");
  const [showAlertsBoard, setShowAlertsBoard] = useState(false);
  const [document, setDocument] = useState("");
  const [queryName, setQueryName] = useState("");
  const componentRef = useRef();
  const printRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });

  const {
    isLoading: isLoadingQueryReview,
    error: errorQueryReview,
    data: data,
  } = useQuery(
    ["data", query],
    async () => {
      const { data } = await axios.get(
        `${QUERIES.GET_USER_QUERY}/${query?.id}`
      );

      setShowAlertsBoard(data?.data?.qc?.showAlertsBoard == 0 ? false : true);
      setDocument(data.data.parameter);
      setQueryName(data?.data?.q?.name);

      return data?.data?.data?.leilaoVipGold || data?.data?.data;
    },
    {
      enabled: !!query,
    }
  );

  const RestrictionItem = ({ text }) => (
    <div className="flex gap-2 items-start text-red-700 font-medium">
      <MdBlock className="mt-0.5" />
      <span>{text}</span>
    </div>
  );

  return (
    <>
      <>
        <div
          className={`overflow-x-scroll print-content mobile-fit ${
            data || isLoadingQueryReview ? "block" : "hidden"
          }`}
          ref={(el) => {
            componentRef.current = el;
            printRef.current = el;
          }}
        >
          {!isLoadingQueryReview ? (
            <>
              <Card className="card-pdf p-5 relative overflow-hidden">
                <HeaderQuery
                  title={queryName}
                  document={document}
                  hasRestrictions={
                    showAlertsBoard ? checkIfHasRestrictions(data) : null
                  }
                />
                <div className="mt-1">
                  <TitleStripe className="mb-4">Dados da Consulta</TitleStripe>

                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    {/* Logo */}
                    {(data?.binEstadual?.urlLogo?.thumb ||
                      data?.binNacional?.urlLogo?.thumb) && (
                      <img
                        className="w-36 h-auto border border-gray-200 rounded-md p-2 shadow-sm"
                        src={
                          data?.binEstadual?.urlLogo?.thumb ||
                          data?.binNacional?.urlLogo?.thumb
                        }
                        alt="Logo"
                      />
                    )}

                    {/* Dados da consulta */}
                    <div className="w-full">
                      <div className="grid grid-cols-3 gap-4">
                        <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 shadow-sm">
                          <p className="text-xs text-gray-500 font-medium uppercase mb-1">
                            Consulta
                          </p>
                          <p className="text-base font-semibold text-gray-800">
                            #{query?.id} {query?.name || "Não informado"}
                          </p>
                        </div>

                        <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 shadow-sm">
                          <p className="text-xs text-gray-500 font-medium uppercase mb-1">
                            Data | Hora
                          </p>
                          <p className="text-base font-semibold text-gray-800">
                            {moment().format("DD/MM/YYYY | HH:mm")}h
                          </p>
                        </div>

                        <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 shadow-sm break-words">
                          {document && (
                            <div className="relative w-fit">
                              <img
                                src="/assets/placa.png"
                                style={{ width: "120px" }}
                              />
                              <div
                                className="absolute top-4 font-semibold text-lg"
                                style={{
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                }}
                              >
                                {document}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {showAlertsBoard && (
                  <div>
                    <TitleStripe>Quadro de avisos</TitleStripe>
                    <div className="container-alerts four-columns mt-3">
                      {data?.leilaoEssencial &&
                        data?.leilaoEssencial?.statusRetorno == 1 && (
                          <>
                            {data?.leilaoEssencial?.ocorrencias?.ocorrencias >
                            0 ? (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Alerta de Leilão
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Alerta de Leilão
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.remarketing &&
                        data?.remarketing?.statusRetorno == 1 && (
                          <>
                            {data?.remarketing?.ocorrencias?.length > 0 ? (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Remarketing</div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Remarketing</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.recall && data?.recall?.statusRetorno == 1 && (
                        <>
                          {data?.recall?.ocorrencias?.length > 0 ? (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Recall</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Recall</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.laudoCsv && data?.laudoCsv?.statusRetorno == 1 && (
                        <>
                          {data?.laudoCsv.recall1 ||
                          data?.laudoCsv.recall2 ||
                          data?.laudoCsv.recall3 ||
                          data?.laudoCsv.recallMontadora ? (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Recall II</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Recall II</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.renainf && data?.renainf?.statusRetorno == 1 && (
                        <>
                          {data?.renainf?.temRenainf == "0" ? (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">RENAINF</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">RENAINF</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.laudoCsv && data?.laudoCsv?.statusRetorno == 1 && (
                        <>
                          {data?.laudoCsv?.renainfs?.length > 0 ? (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Renainf II</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Renainf II</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.renajud && data?.renajud?.statusRetorno == 1 && (
                        <>
                          {data?.renajud?.temRenajud == "0" ? (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">RENAJUD</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">RENAJUD</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.laudoCsv && data?.laudoCsv?.statusRetorno == 1 && (
                        <>
                          {data?.laudoCsv.renajuds?.length > 0 ? (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Renajud II</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Renajud II</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.historicoRouboEFurto &&
                        data?.historicoRouboEFurto?.statusRetorno == 1 && (
                          <>
                            {data?.historicoRouboEFurto
                              ?.temHistoricoRouboEFurto == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Histórico roubo e furto
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Histórico roubo e furto
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.indicioSinistro &&
                        data?.indicioSinistro?.statusRetorno == 1 && (
                          <>
                            {data?.indicioSinistro?.temIndicio == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.indicioSinistro1 &&
                        data?.indicioSinistro1?.statusRetorno == 1 && (
                          <>
                            {data?.indicioSinistro1?.temIndicio == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro I
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro I
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.indicioSinistro3 &&
                        data?.indicioSinistro3?.statusRetorno == 1 && (
                          <>
                            {data?.indicioSinistro3?.temIndicio == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro III
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Indício de sinistro III
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.indicioSinistroIntegral &&
                        data?.indicioSinistroIntegral?.statusRetorno == 1 && (
                          <>
                            {data?.indicioSinistroIntegral?.temIndicio ==
                            "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Sinistro Integral
                                </div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Sinistro Integral
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.gravame && data?.gravame?.statusRetorno == 1 && (
                        <>
                          {data?.gravame?.temGravame == "0" ? (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Gravame</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Gravame</div>
                              <div className="text-center font-semibold">
                                Sim
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.ipva
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">IPVA</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">IPVA</div>
                                <div className="text-center font-semibold">
                                  {formatToReal(
                                    data?.binEstadual?.restricoes?.ipva
                                      ?.valorPendencia
                                  )}
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.dpvat
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">DPVAT</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">DPVAT</div>
                                <div className="text-center font-semibold">
                                  {formatToReal(
                                    data?.binEstadual?.restricoes?.dpvat
                                      ?.valorPendencia
                                  )}
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.multas
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Multas</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Multas</div>
                                <div className="text-center font-semibold">
                                  {formatToReal(
                                    data?.binEstadual?.restricoes?.multas
                                      ?.valorPendencia
                                  )}
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes?.licenciamento
                              ?.existePendencia == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Licenciamento</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Licenciamento</div>
                                <div className="text-center font-semibold">
                                  {formatToReal(
                                    data?.binEstadual?.restricoes?.licenciamento
                                      ?.valorPendencia
                                  )}
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.veiculosPorDocumento &&
                        data?.veiculosPorDocumento?.statusRetorno == 1 && (
                          <>
                            <Alert
                              color="gray"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <MdInfoOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Qtd. Veículos</div>
                              <div className="text-center font-semibold">
                                {data?.veiculosPorDocumento?.veiculos?.length ||
                                  0}{" "}
                                veículos
                              </div>
                            </Alert>
                          </>
                        )}

                      {data?.laudoCsv && data?.laudoCsv?.statusRetorno == 1 && (
                        <>
                          {data?.laudoCsv?.ocorrencias?.length === 0 ? (
                            <Alert
                              color="success"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <IoMdCheckmarkCircleOutline
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Laudo CSV</div>
                              <div className="text-center font-semibold">
                                Nada consta
                              </div>
                            </Alert>
                          ) : (
                            <Alert
                              color="failure"
                              withBorderAccent
                              className="flex justify-center items-center flex-col"
                            >
                              <FiAlertOctagon
                                fontSize={30}
                                className="mx-auto mb-1"
                              />
                              <div className="text-center">Laudo CSV</div>
                              <div className="text-center font-semibold">
                                {data?.laudoCsv?.ocorrencias?.length}{" "}
                                ocorrências
                              </div>
                            </Alert>
                          )}
                        </>
                      )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes
                              ?.existeRestricaoRenajud == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">RENAJUD</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">RENAJUD</div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}

                      {data?.binEstadual &&
                        data?.binEstadual?.statusRetorno == 1 && (
                          <>
                            {data?.binEstadual?.restricoes
                              ?.existeRestricaoRouboFurto == "0" ? (
                              <Alert
                                color="success"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <IoMdCheckmarkCircleOutline
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">Roubo e furto</div>
                                <div className="text-center font-semibold">
                                  Nada consta
                                </div>
                              </Alert>
                            ) : (
                              <Alert
                                color="failure"
                                withBorderAccent
                                className="flex justify-center items-center flex-col"
                              >
                                <FiAlertOctagon
                                  fontSize={30}
                                  className="mx-auto mb-1"
                                />
                                <div className="text-center">
                                  Restrição roubo e furto
                                </div>
                                <div className="text-center font-semibold">
                                  Sim
                                </div>
                              </Alert>
                            )}
                          </>
                        )}
                    </div>
                  </div>
                )}

                <div className="mt-2">
                  <div className="flex flex-col gap-6">
                    {data?.binNacional?.statusRetorno === 1 && (
                      <div className="flex-1 mt-4">
                        <TitleStripe>
                          🚗 Informações do veículo - Nacional
                        </TitleStripe>
                        <div className="flex-1 text-sm bg-gray-50 rounded-lg p-6 mt-3">
                          <div className="grid grid-cols-3 gap-x-6 gap-y-4">
                            {[
                              ["Marca/Modelo", data?.binNacional?.marcaModelo],
                              [
                                "Ano Fabr./Modelo",
                                `${data?.binNacional?.anoFabricacao}/${data?.binNacional?.anoModelo}`,
                              ],
                              [
                                "Tempo de circulação",
                                `${
                                  moment().format("YYYY") -
                                  +data?.binNacional?.anoFabricacao
                                } anos`,
                              ],
                              [
                                "Categoria",
                                data?.binNacional?.categoriaVeiculo,
                              ],
                              [
                                "Tipo de veículo",
                                data?.binNacional?.tipoVeiculo,
                              ],
                              ["Placa", document],
                              ["RENAVAM", data?.binNacional?.renavam],
                              ["Chassi", data?.binNacional?.chassi],
                              ["Situação", data?.binNacional?.situacao],
                              ["Cilindrada", data?.binNacional?.cilindrada],
                              ["CMT", data?.binNacional?.cmt],
                              ["Combustível", data?.binNacional?.combustivel],
                              ["Cor", data?.binNacional?.corVeiculo],
                              [
                                "Emplacamento",
                                data?.binNacional?.dataEmplacamento,
                              ],
                              ["Espécie", data?.binNacional?.especieVeiculo],
                              ["Município", data?.binNacional?.municipio],
                              ["UF", data?.binNacional?.uf],
                              [
                                "Nº Carroceria",
                                data?.binNacional?.numeroCarroceria,
                              ],
                              ["Nº DI", data?.binNacional?.numeroDI],
                              ["Qtd. Eixos", data?.binNacional?.numeroEixos],
                              ["Nº Motor", data?.binNacional?.numeroMotor],
                              ["PBT", data?.binNacional?.PBT],
                              ["Potência", data?.binNacional?.potenciaVeiculo],
                              ["Procedência", data?.binNacional?.procedencia],
                              [
                                "Qtd. Passageiros",
                                data?.binNacional?.quantidadePassageiros,
                              ],
                              [
                                "Situação do chassi",
                                data?.binNacional?.situacaoChassi,
                              ],
                              [
                                "Tipo de Carroceria",
                                data?.binNacional?.tipoCarroceria,
                              ],
                              [
                                "Tipo Doc. Faturado",
                                data?.binNacional?.tipoDocumentoFaturado,
                              ],
                              ["Montagem", data?.binNacional?.tipoMontagem],
                              [
                                "Nº Faturado",
                                data?.binNacional?.numeroIdentificacaoFaturado,
                              ],
                              [
                                "UF Faturamento",
                                data?.binNacional?.ufFaturamento,
                              ],
                              [
                                "Data Atualização",
                                data?.binNacional?.dataAtualizacao,
                              ],
                              [
                                "Data Emissão Último CRV",
                                data?.binNacional?.dataEmissaoUltimoCRV,
                              ],
                            ].map(([label, value], i) => (
                              <div key={i}>
                                <div className="text-xs text-gray-500 uppercase font-medium tracking-wide mb-1">
                                  {label}
                                </div>
                                <div className="text-sm font-semibold text-gray-900">
                                  {value || "Não informado"}
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Restrições */}
                          <div className="mt-6">
                            <h3 className="text-sm font-semibold mb-2">
                              🔒 Restrições Gerais
                            </h3>
                            {data?.binNacional?.restricoes?.mensagensRestricoes
                              ?.length > 0 ? (
                              <ul className="list-disc list-inside text-red-600 space-y-1 font-medium">
                                {data?.binNacional?.restricoes?.mensagensRestricoes
                                  ?.filter((r) => !/nada\s+consta/i.test(r)) // remove "NADA CONSTA"
                                  ?.map((r, i) => (
                                    <li key={i}>Restrição: {r}</li>
                                  ))}
                              </ul>
                            ) : (
                              <div className="text-green-600 font-medium">
                                Nada consta
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {!data?.binNacional &&
                      data?.laudoCsv?.binNacional?.statusRetorno === 1 && (
                        <div className="flex-1">
                          <h2 className="text-lg font-bold border-b pb-2 flex items-center gap-2">
                            🚗 Informações do veículo - Nacional
                            <img
                              className="w-5 h-4s"
                              src="/assets/base_nacional.png"
                              alt="Base Nacional"
                            />
                          </h2>
                          <div className="flex-1 text-sm bg-gray-50 rounded-lg p-6 mt-6">
                            <div className="grid grid-cols-3 gap-x-6 gap-y-4">
                              {[
                                [
                                  "Marca/Modelo",
                                  data?.laudoCsv?.binNacional?.marcaModelo,
                                ],
                                [
                                  "Ano Fabr./Modelo",
                                  `${data?.laudoCsv?.binNacional?.anoFabricacao}/${data?.laudoCsv?.binNacional?.anoModelo}`,
                                ],
                                [
                                  "Tempo de circulação",
                                  `${
                                    moment().format("YYYY") -
                                    +data?.laudoCsv?.binNacional?.anoFabricacao
                                  } anos`,
                                ],
                                [
                                  "Categoria",
                                  data?.laudoCsv?.binNacional?.categoriaVeiculo,
                                ],
                                [
                                  "Tipo de veículo",
                                  data?.laudoCsv?.binNacional?.tipoVeiculo,
                                ],
                                ["Placa", document],
                                [
                                  "RENAVAM",
                                  data?.laudoCsv?.binNacional?.renavam,
                                ],
                                ["Chassi", data?.laudoCsv?.binNacional?.chassi],
                                [
                                  "Situação",
                                  data?.laudoCsv?.binNacional?.situacao,
                                ],
                                [
                                  "Câmbio",
                                  data?.laudoCsv?.binNacional?.caixaCambio,
                                ],
                                [
                                  "Capacidade Carga",
                                  data?.laudoCsv?.binNacional?.capacidadeCarga,
                                ],
                                [
                                  "Cilindrada",
                                  data?.laudoCsv?.binNacional?.cilindrada,
                                ],
                                ["CMT", data?.laudoCsv?.binNacional?.cmt],
                                [
                                  "Combustível",
                                  data?.laudoCsv?.binNacional?.combustivel,
                                ],
                                [
                                  "Cor",
                                  data?.laudoCsv?.binNacional?.corVeiculo,
                                ],
                                [
                                  "Emplacamento",
                                  data?.laudoCsv?.binNacional?.dataEmplacamento,
                                ],
                                [
                                  "Espécie",
                                  data?.laudoCsv?.binNacional?.especieVeiculo,
                                ],
                                [
                                  "Município",
                                  data?.laudoCsv?.binNacional?.municipio,
                                ],
                                ["UF", data?.laudoCsv?.binNacional?.uf],
                                [
                                  "Nº Carroceria",
                                  data?.laudoCsv?.binNacional?.numeroCarroceria,
                                ],
                                [
                                  "Nº DI",
                                  data?.laudoCsv?.binNacional?.numeroDI,
                                ],
                                [
                                  "Qtd. Eixos",
                                  data?.laudoCsv?.binNacional?.numeroEixos,
                                ],
                                [
                                  "Nº Motor",
                                  data?.laudoCsv?.binNacional?.numeroMotor,
                                ],
                                ["PBT", data?.laudoCsv?.binNacional?.PBT],
                                [
                                  "Potência",
                                  data?.laudoCsv?.binNacional?.potenciaVeiculo,
                                ],
                                [
                                  "Procedência",
                                  data?.laudoCsv?.binNacional?.procedencia,
                                ],
                                [
                                  "Qtd. Passageiros",
                                  data?.laudoCsv?.binNacional
                                    ?.quantidadePassageiros,
                                ],
                                [
                                  "Situação do chassi",
                                  data?.laudoCsv?.binNacional?.situacaoChassi,
                                ],
                                [
                                  "Tipo de Carroceria",
                                  data?.laudoCsv?.binNacional?.tipoCarroceria,
                                ],
                                [
                                  "Data Emissão Último CRV",
                                  moment(
                                    data?.laudoCsv?.binNacional
                                      ?.dataEmissaoUltimoCRV
                                  ).format("DD/MM/YYYY"),
                                ],
                              ].map(([label, value], i) => (
                                <div key={i}>
                                  <div className="text-xs text-gray-500 uppercase font-medium tracking-wide mb-1">
                                    {label}
                                  </div>
                                  <div className="text-sm font-semibold text-gray-900">
                                    {value || "Não informado"}
                                  </div>
                                </div>
                              ))}
                            </div>

                            {/* Restrições */}
                            <div className="mt-6">
                              <h3 className="text-sm font-semibold mb-2">
                                🔒 Restrições
                              </h3>
                              {data?.laudoCsv?.binNacional?.restricoes?.length >
                              0 ? (
                                <ul className="list-disc list-inside text-red-600 space-y-1 font-medium">
                                  {data?.laudoCsv?.binNacional?.restricoes.map(
                                    (r, i) => (
                                      <li key={i}>Restrição: {r}</li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <div className="text-green-600 font-medium">
                                  Nada consta
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                    {data?.binEstadual && (
                      <div className="flex-1">
                        <h2 className="text-lg font-bold mb-4 border-b pb-2">
                          🚗 Informações do Veículo - Estadual
                        </h2>

                        {data?.binEstadual?.statusRetorno === 1 ? (
                          <div className="bg-gray-50 rounded-lg p-6">
                            <div className="grid grid-cols-3 gap-x-6 gap-y-4">
                              {[
                                [
                                  "Marca/Modelo",
                                  data?.binEstadual?.marcaModelo,
                                ],
                                [
                                  "Ano Fab./Mod.",
                                  `${data?.binEstadual?.anoFabricacao}/${data?.binEstadual?.anoModelo}`,
                                ],
                                [
                                  "Tempo de circulação",
                                  `${
                                    moment().format("YYYY") -
                                    +data?.binEstadual?.anoFabricacao
                                  } anos`,
                                ],
                                [
                                  "Categoria",
                                  data?.binEstadual?.categoriaVeiculo,
                                ],
                                [
                                  "Tipo de veículo",
                                  data?.binEstadual?.tipoVeiculo,
                                ],
                                ["Placa", document],
                                ["RENAVAM", data?.binEstadual?.renavam],
                                ["Chassi", data?.binEstadual?.chassi],
                                ["Situação", data?.binEstadual?.situacao],
                                ["Cilindrada", data?.binEstadual?.cilindrada],
                                ["CMT", data?.binEstadual?.cmt],
                                ["Combustível", data?.binEstadual?.combustivel],
                                ["Cor", data?.binEstadual?.corVeiculo],
                                [
                                  "Emplacamento",
                                  data?.binEstadual?.dataEmissaoUltimoCRV,
                                ],
                                ["Espécie", data?.binEstadual?.especieVeiculo],
                                ["Município", data?.binEstadual?.municipio],
                                ["UF", data?.binEstadual?.uf],
                                [
                                  "Nº Carroceria",
                                  data?.binEstadual?.numeroCarroceria,
                                ],
                                ["Qtd. Eixos", data?.binEstadual?.numeroEixos],
                                ["Nº Motor", data?.binEstadual?.numeroMotor],
                                ["PBT", data?.binEstadual?.pbt],
                                [
                                  "Potência",
                                  data?.binEstadual?.potenciaVeiculo,
                                ],
                                ["Procedência", data?.binEstadual?.procedencia],
                                [
                                  "Qtd. Passageiros",
                                  data?.binEstadual?.quantidadePassageiros,
                                ],
                                [
                                  "Situação do chassi",
                                  data?.binEstadual?.situacaoChassi,
                                ],
                                [
                                  "Tipo de Carroceria",
                                  data?.binEstadual?.tipoCarroceria,
                                ],
                                [
                                  "Tipo Doc. Faturado",
                                  data?.binEstadual?.tipoDocumentoFaturado,
                                ],
                                [
                                  "Nº Faturado",
                                  data?.binEstadual
                                    ?.numeroIdentificacaoFaturado,
                                ],
                                [
                                  "UF Faturamento",
                                  data?.binEstadual?.ufFaturamento,
                                ],
                                [
                                  "Débitos Municipais",
                                  formatToReal(
                                    data?.binEstadual?.debitosMunicipais
                                  ),
                                ],
                                [
                                  "Proprietário Anterior",
                                  data?.binEstadual?.proprietarioAnterior,
                                ],
                              ].map(([label, value], index) => (
                                <div key={index}>
                                  <div className="text-xs text-gray-500 uppercase font-medium tracking-wide mb-1">
                                    {label}
                                  </div>
                                  <div className="text-sm font-semibold text-gray-900">
                                    {value || "Não Informado"}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <Alert withBorderAccent color="gray" className="mt-4">
                            Consulta Indisponível no momento
                          </Alert>
                        )}
                      </div>
                    )}
                  </div>
                  {data?.binEstadual &&
                    data?.binEstadual?.statusRetorno == 1 && (
                      <div className="bg-gray-50 p-6 rounded-lg text-sm mt-4">
                        {/* Proprietário */}
                        <div>
                          <h3 className="text-base font-semibold border-b pb-1 mb-3">
                            👤 Proprietário | Estadual
                          </h3>
                          <div className="flex gap-4">
                            <div>
                              <span className="text-xs text-gray-500 uppercase">
                                Nome:
                              </span>
                              <div className="font-medium text-gray-800">
                                {data?.binEstadual?.proprietario?.nome ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div>
                              <span className="text-xs text-gray-500 uppercase">
                                Documento:
                              </span>
                              <div className="font-medium text-gray-800">
                                {data?.binEstadual?.proprietario?.documento
                                  ? formatDocument(
                                      data?.binEstadual?.proprietario?.documento
                                    )
                                  : "Não informado"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Restrições */}
                        <div className="mt-4">
                          <h3 className="text-base font-semibold border-b pb-1 mb-3">
                            🔒 Restrições | Estadual
                          </h3>
                          {[
                            data?.binEstadual?.restricoes
                              ?.existeRestricaoRouboFurto,
                            data?.binEstadual?.restricoes?.veiculoBaixado,
                            data?.binEstadual?.restricoes
                              ?.existeRestricaoRenajud,
                            data?.binEstadual?.restricoes?.existeRestricaoGeral,
                            (data?.binEstadual?.outrasRestricoes || []).length >
                              0,
                          ].every(
                            (v) => v === "0" || v === false || v === undefined
                          ) ? (
                            <div className="flex items-center gap-2 font-medium text-green-700">
                              <IoMdCheckmarkCircleOutline />
                              <span>Não constam restrições</span>
                            </div>
                          ) : (
                            <div className="space-y-2">
                              {data?.binEstadual?.restricoes
                                ?.existeRestricaoRouboFurto === "1" && (
                                <RestrictionItem text="Restrição: Roubo e furto" />
                              )}
                              {data?.binEstadual?.restricoes
                                ?.existeRestricaoRenajud === "1" && (
                                <RestrictionItem text="Restrição: Renajud" />
                              )}
                              {data?.binEstadual?.restricoes
                                ?.existeRestricaoGeral === "1" && (
                                <RestrictionItem text="Restrição: Geral" />
                              )}
                              {data?.binEstadual?.restricoes?.veiculoBaixado ===
                                "1" && (
                                <RestrictionItem text="Restrição: Veículo Baixado" />
                              )}
                              {data?.binEstadual?.outrasRestricoes?.map(
                                (r, idx) => (
                                  <RestrictionItem
                                    text={`Restrição: ${r}`}
                                    key={idx}
                                  />
                                )
                              )}
                            </div>
                          )}
                        </div>

                        {/* Débitos */}
                        <div className="mt-4">
                          <h3 className="text-base font-semibold border-b pb-1 mb-3">
                            💰 Multas e Débitos | Estadual
                          </h3>
                          <div className="space-y-3">
                            {[
                              ["dpvat", "DPVAT"],
                              ["ipva", "IPVA"],
                              ["licenciamento", "Licenciamento"],
                              ["multas", "Multas"],
                            ].map(([key, label]) => {
                              const item = data?.binEstadual?.restricoes?.[key];
                              return (
                                <div
                                  key={key}
                                  className="flex items-center gap-2 font-medium"
                                >
                                  {item?.existePendencia == "1" ? (
                                    <MdBlock color="red" />
                                  ) : (
                                    <IoMdCheckmarkCircleOutline color="green" />
                                  )}
                                  <span>Débitos: {label}</span>
                                  {item?.existePendencia == "1" &&
                                    item?.valorPendencia && (
                                      <span className="text-gray-600">
                                        | {formatToReal(item.valorPendencia)}
                                      </span>
                                    )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                {data?.leilaoEssencial && (
                  <div>
                    <TitleStripe>
                      🔨 Dados de Leilão Realizado - Base III
                    </TitleStripe>

                    {data?.leilaoEssencial?.statusRetorno == "1" ? (
                      <>
                        {data?.leilaoEssencial?.ocorrencias?.ocorrencias
                          ?.length === 0 ? (
                          <NoOcurrence />
                        ) : (
                          <>
                            <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                              <Table striped className="w-full text-xs">
                                <Table.Head>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Leiloeiro
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Data
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Lote
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Pátio
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Situação chassi
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Condição Geral
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Comitente
                                  </Table.HeadCell>
                                </Table.Head>
                                <Table.Body>
                                  {data?.leilaoEssencial?.ocorrencias?.ocorrencias?.map(
                                    (leilao, index) => (
                                      <Table.Row
                                        key={index}
                                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                      >
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.leiloeiro || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.dataLeilao || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.lote || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.patio || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.situacaoChassi || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.condicaoGeralVeiculo || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {leilao?.comitente || "-"}
                                        </Table.Cell>
                                      </Table.Row>
                                    )
                                  )}
                                </Table.Body>
                              </Table>
                            </div>
                            {data?.leilaoEssencial?.score
                              ?.descricaoPontuacao && (
                              <>
                                <div className="title-vehicle mt-5">
                                  Descrição da pontuação
                                </div>
                                <div className="mt-2 font-semibold">
                                  {
                                    data?.leilaoEssencial?.score
                                      ?.descricaoPontuacao
                                  }
                                </div>
                              </>
                            )}

                            {data?.leilaoEssencial?.score?.aceitacao && (
                              <>
                                {" "}
                                <div className="title-vehicle mt-5">
                                  Aceitação de Seguro
                                </div>
                                <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a régua aponta
                                  a probabilidade de 0% a 100% do veículo ser
                                  segurado nas principais seguradoras do país.
                                </div>
                                <div className="square">
                                  <FaCar
                                    fontSize={28}
                                    style={{
                                      left: `${
                                        data?.leilaoEssencial?.score
                                          ?.aceitacao === "100"
                                          ? +data?.leilaoEssencial?.score
                                              ?.aceitacao - 4
                                          : data?.leilaoEssencial?.score
                                              ?.aceitacao
                                      }%`,
                                    }}
                                  />
                                </div>
                                <div className="font-bold flex justify-end -mt-4">
                                  {data?.leilaoEssencial?.score?.aceitacao}%
                                </div>
                              </>
                            )}

                            {data?.leilaoEssencial?.score
                              ?.percentualSobreTabelaReferencia && (
                              <>
                                {" "}
                                <div className="title-vehicle mt-5">
                                  Percentual sobre a Tabela de Referência
                                </div>
                                <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a régua aponta
                                  o possível percentual da tabela de referência
                                  (fipe) utilizada pela seguradora no momento da
                                  contratação do seguro do bem.
                                </div>
                                <div className="square">
                                  <FaCar
                                    fontSize={28}
                                    style={{
                                      left: `${
                                        data?.leilaoEssencial?.score
                                          ?.percentualSobreTabelaReferencia ===
                                        "100"
                                          ? +data?.leilaoEssencial?.score
                                              ?.percentualSobreTabelaReferencia -
                                            4
                                          : data?.leilaoEssencial?.score
                                              ?.percentualSobreTabelaReferencia
                                      }%`,
                                    }}
                                  />
                                </div>
                                <div className="font-bold flex justify-end -mt-4">
                                  {
                                    data?.leilaoEssencial?.score
                                      ?.percentualSobreTabelaReferencia
                                  }
                                  %
                                </div>
                              </>
                            )}

                            {data?.leilaoEssencial?.score
                              ?.exigeVistoriaEspecial && (
                              <>
                                <div className="title-vehicle mt-5">
                                  Necessidade de Vistoria Especial
                                </div>
                                <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a régua aponta
                                  a menor ou maior probabilidade de exigência de
                                  vistoria especial por parte da seguradora.
                                </div>
                                <div className="square">
                                  <FaCar
                                    fontSize={28}
                                    style={{
                                      left: `${data?.leilaoEssencial?.score?.percentualSobreTabelaReferencia}%`,
                                    }}
                                  />
                                </div>
                                <div className="font-bold flex justify-end -mt-4">
                                  {
                                    data?.leilaoEssencial?.score
                                      ?.exigeVistoriaEspecial
                                  }
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.imagensLeilao && (
                  <div>
                    <TitleStripe>📸 Imagens de leilão</TitleStripe>

                    {data?.imagensLeilao?.statusRetorno == "1" ? (
                      <>
                        {data?.imagensLeilao?.ocorrencias?.length === 0 ? (
                          <NoOcurrence />
                        ) : (
                          <>
                            {data?.imagensLeilao?.ocorrencias?.map(
                              (leilao, indexL) => (
                                <div key={indexL}>
                                  <div className="title-vehicle mt-3">
                                    Base {leilao.numeroLeilao}
                                  </div>

                                  {leilao?.imagens?.length > 0 ? (
                                    <div className="grid grid-cols-4 gap-4 mt-3">
                                      {leilao?.imagens?.map((img, idx) => (
                                        <img key={idx} src={img?.url} />
                                      ))}
                                    </div>
                                  ) : (
                                    <NoOcurrence />
                                  )}
                                </div>
                              )
                            )}
                            <small className="block mt-2 mx-auto">
                              Obs: Imagens Ilustrativas
                            </small>
                          </>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Não foram encontradas imagens para este veículo.
                      </Alert>
                    )}
                  </div>
                )}

                {data?.remarketing && (
                  <div>
                    <TitleStripe>🔁 Remarketing</TitleStripe>

                    {data?.remarketing?.statusRetorno == "1" ? (
                      <>
                        {data?.remarketing?.ocorrencias?.length === 0 ? (
                          <NoOcurrence />
                        ) : (
                          <>
                            <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                              <Table striped className="w-full text-xs">
                                <Table.Head>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Organizador
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Vendedor
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Data
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Cond. Veículo
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Sit. Chassi
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Cond. Motor
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Cond. Mecânica
                                  </Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                  {data?.remarketing?.ocorrencias?.map(
                                    (remarketing, index) => (
                                      <Table.Row
                                        key={index}
                                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                      >
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.organizador || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.vendedor || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.dataEvento || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.condicaoVeiculo || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.situacaoChassi || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.condicaoMotor || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {remarketing?.condicaoMecanica || "-"}
                                        </Table.Cell>
                                      </Table.Row>
                                    )
                                  )}
                                </Table.Body>
                              </Table>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.recall && (
                  <div>
                    <TitleStripe>🛠️ Recall</TitleStripe>

                    {data?.recall?.statusRetorno == "1" ? (
                      <>
                        {data?.recall?.ocorrencias?.length === 0 ? (
                          <NoOcurrence />
                        ) : (
                          <>
                            <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                              <Table striped className="w-full text-xs">
                                <Table.Head>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Ano Modelo
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Ano Fab.
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Defeito
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Risco
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Data Registro
                                  </Table.HeadCell>
                                  <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                    Situação
                                  </Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                  {data?.recall?.ocorrencias?.map(
                                    (recall, index) => (
                                      <Table.Row
                                        key={index}
                                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                      >
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.anoModelo || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.anoFabricacao || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.defeito || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.risco || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.dataRegistro || "-"}
                                        </Table.Cell>
                                        <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                          {recall?.situacao || "-"}
                                        </Table.Cell>
                                      </Table.Row>
                                    )
                                  )}
                                </Table.Body>
                              </Table>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.agregados && (
                  <div className="mt-6">
                    <TitleStripe>🧩 Agregados</TitleStripe>

                    {data.agregados.statusRetorno === 1 ? (
                      <div className="mt-4 bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                        <div className="grid grid-cols-2 gap-y-4 gap-x-8">
                          {[
                            {
                              label: "Marca/Modelo",
                              value: data.agregados.marcaModelo,
                            },
                            { label: "UF", value: data.agregados.uf },
                            {
                              label: "Ano de Fabricação",
                              value: data.agregados.anoFabricacao,
                            },
                            {
                              label: "Ano do Modelo",
                              value: data.agregados.anoModelo,
                            },
                            {
                              label: "Qtd. Eixos",
                              value: data.agregados.numeroEixos,
                            },
                            {
                              label: "Tempo de circulação",
                              value: data.agregados.tempoCirculacao,
                            },
                            {
                              label: "Nº Motor",
                              value: data.agregados.numeroMotor,
                            },
                            {
                              label: "Tipo do veículo",
                              value: data.agregados.tipoVeiculo,
                            },
                            { label: "PBT", value: data.agregados.pbt },
                            { label: "Placa", value: data.agregados.placa },
                            {
                              label: "Potência",
                              value: data.agregados.potenciaVeiculo,
                            },
                            { label: "Chassi", value: data.agregados.chassi },
                            {
                              label: "Procedência",
                              value: data.agregados.procedencia,
                            },
                            {
                              label: "Capacidade de carga",
                              value: data.agregados.capacidadeCarga,
                            },
                            {
                              label: "Qtd. Passageiros",
                              value: data.agregados.quantidadePassageiros,
                            },
                            {
                              label: "Cilindradas",
                              value: data.agregados.cilindrada,
                            },
                            {
                              label: "Renavam",
                              value: data.agregados.renavam,
                            },
                            { label: "CMT", value: data.agregados.cmt },
                            {
                              label: "Combustível",
                              value: data.agregados.combustivel,
                            },
                            {
                              label: "Tipo Doc. Faturado",
                              value: data.agregados.tipoDocumentoFaturado,
                            },
                            { label: "Cor", value: data.agregados.cor },
                            {
                              label: "Nº Faturado",
                              value: data.agregados.numeroIdentificacaoFaturado,
                            },
                            {
                              label: "Espécie",
                              value: data.agregados.especieVeiculo,
                            },
                            {
                              label: "UF Faturamento",
                              value: data.agregados.ufFaturamento,
                            },
                            {
                              label: "Município",
                              value: data.agregados.municipio,
                            },
                            {
                              label: "Data atualização",
                              value: data.agregados.dataAtualizacao,
                            },
                          ].map(({ label, value }, idx) => (
                            <div
                              key={idx}
                              className="border-b border-gray-100 pb-2"
                            >
                              <div className="text-gray-500 text-xs uppercase tracking-wide">
                                {label}
                              </div>
                              <div
                                className={`mt-1 text-sm font-semibold ${
                                  !value
                                    ? "text-gray-400 italic"
                                    : "text-gray-900"
                                }`}
                              >
                                {value || "Sem informação"}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta indisponível no momento.
                      </Alert>
                    )}
                  </div>
                )}

                {data?.historicoRouboEFurto && (
                  <div>
                    <TitleStripe>🔒 Histórico de roubo e furto</TitleStripe>
                    {data?.historicoRouboEFurto?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.historicoRouboEFurto?.temHistoricoRouboEFurto ==
                        0 ? (
                          <NoOcurrence />
                        ) : (
                          <div>
                            {data?.historicoRouboEFurto?.ocorrencias?.map(
                              (historico, index) => (
                                <div
                                  key={index}
                                  className="bg-red-100 p-2 mt-3"
                                >
                                  <div className="font-semibold">
                                    {historico.tipoOcorrencia ||
                                      "Não informado"}
                                  </div>
                                  <div className="grid grid-cols-2 text-sm gap-1 mt-2">
                                    <div className="flex items-center gap-2">
                                      <div className="font-semibold">
                                        Ano boletim:
                                      </div>
                                      <div>
                                        {historico.anoBoletim ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <div className="font-semibold">
                                        Data ocorrência:
                                      </div>
                                      <div>
                                        {historico.dataOcorrencia ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <div className="font-semibold">
                                        Código órgão de segurança:
                                      </div>
                                      <div>
                                        {historico.codigoOrgaoSeguranca ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <div className="font-semibold">
                                        Nº boletim:
                                      </div>
                                      <div>
                                        {historico.numeroBoletim ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}
                {data?.gravame && (
                  <div className="mt-6">
                    <TitleStripe>📝 Gravame</TitleStripe>

                    {data?.gravame?.statusRetorno == 1 ? (
                      <>
                        {data?.gravame?.temGravame == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div className="space-y-3 mt-4">
                            {data?.gravame?.ocorrencias?.map(
                              (gravame, index) => (
                                <div
                                  key={index}
                                  className="rounded-xl border border-gray-200 bg-white p-6 hover:shadow-md transition"
                                >
                                  <div className="flex justify-between items-center mb-4">
                                    <h4 className="text-lg font-semibold text-gray-800">
                                      Ocorrência #{index + 1}
                                    </h4>
                                    <span className="text-sm text-gray-500">
                                      {gravame?.dataInclusaoGravame ||
                                        "Data não informada"}
                                    </span>
                                  </div>

                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 text-sm text-gray-700">
                                    <div>
                                      <span className="block text-gray-500">
                                        Status Veículo
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.statusVeiculo ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Renavam
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.renavam || "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        UF da Placa
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.ufPlaca || "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Placa
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.placa || "Indisponível"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        UF Licenciamento
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.ufLicenciamento ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Doc. Financiado
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.docFinanciado ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Nome Financiado
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.nomeFinanciado ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Nome Agente
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.nomeAgente ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Doc. Agente
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.docAgente || "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Nº Contrato
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.numeroContrato ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                    <div>
                                      <span className="block text-gray-500">
                                        Data Contrato
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {gravame?.dataContrato ||
                                          "Sem informação"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta indisponível no momento.
                      </Alert>
                    )}
                  </div>
                )}

                {data?.renajud && (
                  <div>
                    <TitleStripe>⚖️ Renajud</TitleStripe>
                    {data?.renajud?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.renajud?.temRenajud == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div>
                            {data?.renajud?.ocorrencias?.map(
                              (renajud, index) => (
                                <div
                                  key={index}
                                  className="bg-red-100 p-2 grid-cols-2 grid gap-2 mt-2 text-sm"
                                >
                                  <div>
                                    <div className="font-semibold">
                                      Órgão Judiciário
                                    </div>
                                    <div>
                                      {renajud?.nomeOrgaoJudicial ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="font-semibold">
                                      Restrições
                                    </div>
                                    <div>
                                      {renajud?.tipoRestricaoJudicial ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="font-semibold">
                                      Processo
                                    </div>
                                    <div>
                                      {renajud?.numeroDoProcesso ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="font-semibold">
                                      Tribunal
                                    </div>
                                    <div>
                                      {renajud?.codigoTribunal ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.renainf && (
                  <div>
                    <TitleStripe>📋 Renainf</TitleStripe>
                    {data?.renainf?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.renainf?.temRenainf == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div>
                            {data?.renainf?.ocorrencias?.map(
                              (renainf, index) => (
                                <div key={index}>
                                  <div className="bg-gray-200 p-2 mt-3 font-semibold text-red-800">
                                    Renainf - Infração/
                                    {renainf?.detalheNumAutoInfracao ||
                                      "Não informado"}
                                  </div>
                                  <div className="bg-red-100 p-2 grid-cols-2 grid gap-2 text-sm">
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Auto de infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheNumAutoInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Limite permitido:
                                      </div>
                                      <div>
                                        {renainf?.detalheLimitePermitido ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Data de infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheDtInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Local infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheLocalInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Exigibilidade:
                                      </div>
                                      <div>
                                        {renainf?.exigibilidade ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Marca/Modelo:
                                      </div>
                                      <div>
                                        {renainf?.detalheMarcaModelo ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Infração:
                                      </div>
                                      <div>
                                        {renainf?.infracao || "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Medição considerada:
                                      </div>
                                      <div>
                                        {renainf?.detalheMedicaoConsiderada ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Órgão autuador:
                                      </div>
                                      <div>
                                        {renainf?.detalheOrgaoAutuador ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Medição real:
                                      </div>
                                      <div>
                                        {renainf?.detalheMedicaoReal ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Cadastro infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheCadastramentoInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Cod. Infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheCodInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Cod. Município emplacamento:
                                      </div>
                                      <div>
                                        {renainf?.detalheCodMunInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Placa:
                                      </div>
                                      <div>{renainf?.detalhePlaca}</div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Data Emissão penalidade:
                                      </div>
                                      <div>
                                        {renainf?.detalheDtEmissaoPenalidade ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Valor da infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheValorInfracao ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Data/Hora da infração:
                                      </div>
                                      <div>
                                        {renainf?.detalheDtInfracao} |{" "}
                                        {renainf?.detalheHrInfracao}
                                      </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                      <div className="font-semibold">
                                        Valor pago:
                                      </div>
                                      <div>
                                        {renainf?.dadosPagamentoValorPago ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.indicioSinistro && (
                  <div>
                    <TitleStripe>⚠️ Indício de sinistro</TitleStripe>
                    {data?.indicioSinistro?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.indicioSinistro?.temIndicio == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div className="bg-red-100 p-2 mt-3">
                            {data?.indicioSinistro?.msgIndicio}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.indicioSinistro1 && (
                  <div>
                    <TitleStripe>⚠️ Indício de sinistro - Base I</TitleStripe>
                    {data?.indicioSinistro1?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.indicioSinistro1?.temIndicio == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div className="bg-red-100 p-2 mt-3">
                            {data?.indicioSinistro1?.msgIndicio}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.indicioSinistro3 && (
                  <div>
                    <TitleStripe>⚠️ Indício de sinistro - Base III</TitleStripe>
                    {data?.indicioSinistro3?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.indicioSinistro3?.temIndicio == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div className="bg-red-100 p-2 mt-3">
                            {data?.indicioSinistro3?.msgIndicio}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.indicioSinistroIntegral && (
                  <div>
                    <TitleStripe>⚠️ Sinistro Integral</TitleStripe>
                    {data?.indicioSinistroIntegral?.statusRetorno == 1 ? (
                      <>
                        {data?.indicioSinistroIntegral?.temIndicio == 0 ? (
                          <NoOcurrence />
                        ) : (
                          <div className="bg-red-100 p-2 mt-3">
                            {data?.indicioSinistroIntegral?.msgIndicio}
                          </div>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.decodificador && (
                  <div>
                    <TitleStripe>🔍 Decodificador</TitleStripe>
                    {data?.decodificador?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        {data?.decodificador?.chassi && (
                          <div className="bg-gray-100 rounded-md p-2 text-center mt-3 ">
                            <div className="text-2xs uppercase">Chassi</div>
                            <div className="font-semibold tracking-widest uppercase">
                              {data?.decodificador?.chassi}
                            </div>
                          </div>
                        )}
                        <div className="grid grid-cols-2 text-sm mt-3 gap-x-10 gap-y-2 p-2">
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Chassi:</div>
                            <div>{data?.decodificador?.chassi || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Marca/Modelo:</div>
                            <div>{data?.decodificador?.marcaModelo || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Combustível:</div>
                            <div>{data?.decodificador?.combustivel}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Cor:</div>
                            <div>{data?.decodificador?.cor || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Motor:</div>
                            <div>{data?.decodificador?.numeroMotor || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">
                              Ano Fabricação/Modelo:
                            </div>
                            <div>
                              {" "}
                              {data?.decodificador?.anoFabricacao}/
                              {data?.decodificador?.anoModelo}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Tipo:</div>
                            <div>{data?.decodificador?.tipoCarroceria}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Peso Bruto:</div>
                            <div>
                              {data?.decodificador?.pesoBrutoTotal || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Qtd. de Portas:</div>
                            <div>{data?.decodificador?.qtdPortas || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Qtd. de eixos:</div>
                            <div>{data?.decodificador?.numeroEixos || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Tração:</div>
                            <div>{data?.decodificador?.tracao || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Transmissão:</div>
                            <div>{data?.decodificador?.transmissao || "-"}</div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Veículo:</div>
                            <div>
                              {data?.decodificador?.especieVeiculo || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Classificação:</div>
                            <div>
                              {data?.decodificador?.classificacao || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">Fabricante:</div>
                            <div>
                              {data?.decodificador?.fabricanteChassi || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">
                              Local da fábrica:
                            </div>
                            <div>
                              {data?.decodificador?.localFabrica || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">
                              Região geográfica:
                            </div>
                            <div>
                              {data?.decodificador?.continenteChassi || "-"}
                            </div>
                          </div>
                          <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                            <div className="font-semibold">País:</div>
                            <div>{data?.decodificador?.paisChassi || "-"}</div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.precificador && (
                  <section>
                    <TitleStripe>🏷️ Precificador</TitleStripe>

                    {data?.precificador?.statusRetorno == 1 ? (
                      <>
                        {/* Quando vier tabela estruturada do provider */}
                        {data?.precificador?.precificador ? (
                          <div
                            className="
              mt-3 rounded-2xl border border-gray-200/80 bg-white/70 backdrop-blur
              ring-1 ring-gray-100 shadow-sm p-4 sm:p-6
            "
                          >
                            <div className="flex items-center justify-between gap-4">
                              <div>
                                <div className="text-[11px] uppercase tracking-wider text-gray-500">
                                  Resultado
                                </div>
                                <h3 className="text-sm font-semibold text-gray-800">
                                  Tabela do Precificador
                                </h3>
                              </div>

                              {/* Selo de vigência (se houver) */}
                              {data?.precificador?.vigencia && (
                                <span className="inline-flex items-center rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700">
                                  Vigência: {data.precificador.vigencia}
                                </span>
                              )}
                            </div>

                            <div className="mt-4">
                              <PrecificadorTabela
                                data={data?.precificador?.precificador}
                              />
                            </div>
                          </div>
                        ) : (
                          /* Versão "resumo" com valor + detalhes */
                          <div
                            className="
              mt-3 rounded-2xl border border-gray-200/80 bg-white/70 backdrop-blur
              ring-1 ring-gray-100 shadow-sm overflow-hidden
            "
                          >
                            {/* Cabeçalho com valor principal */}
                            <div className="relative p-5 sm:p-6">
                              {/* Halo decorativo */}
                              <div
                                aria-hidden
                                className="pointer-events-none absolute -inset-16 opacity-50"
                                style={{
                                  background:
                                    "radial-gradient(700px 220px at 50% -10%, rgba(99,102,241,0.10), transparent 60%)",
                                }}
                              />
                              <div className="relative z-[1] flex flex-wrap items-center justify-between gap-3">
                                <div>
                                  <div className="text-[11px] uppercase tracking-wider text-gray-500">
                                    Valor estimado
                                  </div>
                                  <div className="text-3xl sm:text-4xl font-extrabold tracking-tight tabular-nums text-gray-900">
                                    {formatToReal(data?.precificador?.valor)}
                                  </div>
                                </div>

                                <div className="flex flex-wrap items-center gap-2">
                                  {data?.precificador?.vigencia && (
                                    <span className="inline-flex items-center rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700">
                                      Vigência: {data.precificador.vigencia}
                                    </span>
                                  )}
                                  {data?.precificador?.tipo && (
                                    <span className="inline-flex items-center rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700">
                                      {data.precificador.tipo}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Grid de atributos */}
                            <div className="border-t border-gray-100 bg-blue-50 px-5 py-4 sm:px-6">
                              <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
                                <div className="min-w-0">
                                  <dt className="text-[11px] uppercase tracking-wide text-gray-500">
                                    Marca / Modelo
                                  </dt>
                                  <dd className="truncate text-sm font-medium text-gray-800">
                                    {data?.precificador?.marcaModelo || "—"}
                                  </dd>
                                </div>
                                <div className="min-w-0">
                                  <dt className="text-[11px] uppercase tracking-wide text-gray-500">
                                    Chassi
                                  </dt>
                                  <dd className="truncate text-sm font-medium text-gray-800">
                                    {data?.precificador?.chassi || "—"}
                                  </dd>
                                </div>

                                <div className="min-w-0">
                                  <dt className="text-[11px] uppercase tracking-wide text-gray-500">
                                    Tipo
                                  </dt>
                                  <dd className="truncate text-sm font-medium text-gray-800">
                                    {data?.precificador?.tipo || "—"}
                                  </dd>
                                </div>
                                <div className="min-w-0">
                                  <dt className="text-[11px] uppercase tracking-wide text-gray-500">
                                    Vigência
                                  </dt>
                                  <dd className="truncate text-sm font-medium text-gray-800">
                                    {data?.precificador?.vigencia || "—"}
                                  </dd>
                                </div>
                              </dl>

                              {/* Delta opcional vs preço de anúncio (se existir) */}
                              {(data?.precoAnuncio || data?.veiculo?.preco) &&
                                (() => {
                                  const anuncio = Number(
                                    data?.precoAnuncio ?? data?.veiculo?.preco
                                  );
                                  const fipe = Number(
                                    data?.precificador?.valor
                                  );
                                  if (
                                    !Number.isFinite(anuncio) ||
                                    !Number.isFinite(fipe) ||
                                    fipe <= 0
                                  )
                                    return null;
                                  const delta = anuncio - fipe;
                                  const pct = (delta / fipe) * 100;
                                  const up = delta > 0;
                                  return (
                                    <div className="mt-3 flex flex-wrap items-center gap-2">
                                      <span
                                        className={[
                                          "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold",
                                          up
                                            ? "bg-red-50 text-red-700 border border-red-100"
                                            : "bg-emerald-50 text-emerald-700 border border-emerald-100",
                                        ].join(" ")}
                                        title="Diferença do anúncio vs valor estimado"
                                      >
                                        {up ? "▲" : "▼"}{" "}
                                        {formatToReal(Math.abs(delta))} (
                                        {pct.toFixed(1)}%)
                                      </span>
                                      <span className="text-[11px] text-gray-500">
                                        {up ? "acima" : "abaixo"} do valor
                                        estimado
                                      </span>
                                    </div>
                                  );
                                })()}
                            </div>

                            {/* Rodapé sutil */}
                            <div className="border-t border-gray-100 bg-gray-50 px-5 py-3 sm:px-6">
                              <p className="text-[11px] text-gray-500">
                                Valores podem variar conforme estado de
                                conservação, quilometragem e região.
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="mt-4 rounded-xl border border-gray-200 bg-white/70 backdrop-blur ring-1 ring-gray-100 p-4">
                        <div className="text-sm text-gray-700 font-medium">
                          Consulta indisponível no momento.
                        </div>
                        <div className="text-[12px] text-gray-500 mt-1">
                          Tente novamente em alguns instantes.
                        </div>
                      </div>
                    )}
                  </section>
                )}

                {data?.tabelaFipe && (
                  <div>
                    <TitleStripe>📊 Tabela fipe</TitleStripe>

                    {data?.tabelaFipe?.statusRetorno == 1 ? (
                      <>
                        {data?.tabelaFipe?.ocorrencias?.length > 0 ? (
                          <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                            <Table striped className="w-full text-xs">
                              <Table.Head>
                                <Table.HeadCell className="bg-gray-300 px-1 py-1">
                                  Modelo
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Ano Modelo
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Código
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Vigência
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Preço
                                </Table.HeadCell>
                              </Table.Head>
                              <Table.Body className="divide-y">
                                {data?.tabelaFipe?.ocorrencias?.map(
                                  (fipe, index) => (
                                    <Table.Row
                                      key={index}
                                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                    >
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white px-1 py-1">
                                        {fipe?.fabricanteModelo || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {fipe?.anoModelo || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {fipe?.codigo || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {fipe?.vigencia || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1 font-semibold">
                                        {fipe?.preco ? (
                                          <Badge
                                            color="blue"
                                            className="w-fit mx-auto"
                                          >
                                            {fipe?.preco}
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                                )}
                              </Table.Body>
                            </Table>
                          </div>
                        ) : (
                          <NoOcurrence />
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.proprietarioAtual && (
                  <div className="mt-4">
                    <TitleStripe>👤 Proprietário Atual</TitleStripe>

                    {data?.proprietarioAtual?.statusRetorno == 1 ? (
                      <div className="mt-4">
                        {/* Dados do proprietário */}
                        <div className="flex flex-row items-center gap-6 mb-8">
                          {/* Avatar do Proprietário */}
                          <div className="flex items-center justify-center w-28 min-w-28 h-28 rounded-full bg-green-100 border border-green-200">
                            <FaUser className="text-green-600" fontSize={40} />
                          </div>

                          {/* Dados do Proprietário */}
                          <div className="grid grid-cols-2 gap-4 w-full">
                            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                              <p className="text-[11px] text-gray-500 font-semibold uppercase mb-1 tracking-wide">
                                Nome do Proprietário
                              </p>
                              <p className="text-gray-800 font-bold text-base">
                                {data?.proprietarioAtual?.proprietario
                                  ?.nomeProprietario || "Não informado"}
                              </p>
                            </div>

                            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                              <p className="text-[11px] text-gray-500 font-semibold uppercase mb-1 tracking-wide">
                                Documento
                              </p>
                              <p className="text-gray-800 font-bold text-base">
                                {data?.proprietarioAtual?.proprietario
                                  ?.documentoProprietario
                                  ? formatDocument(
                                      data?.proprietarioAtual?.proprietario
                                        ?.documentoProprietario
                                    )
                                  : "Não informado"}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Informações do veículo */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
                          {[
                            {
                              label: "Marca/Modelo",
                              value: data?.proprietarioAtual?.marcaModelo,
                            },
                            {
                              label: "Ano Fabricação/Modelo",
                              value: `${data?.proprietarioAtual?.anoFabricacao}/${data?.proprietarioAtual?.anoModelo}`,
                            },
                            {
                              label: "Placa",
                              value: data?.proprietarioAtual?.placa,
                            },
                            {
                              label: "UF",
                              value: data?.proprietarioAtual?.uf,
                            },
                            {
                              label: "Município",
                              value: data?.proprietarioAtual?.munipio,
                            },
                            {
                              label: "Chassi",
                              value: data?.proprietarioAtual?.chassi,
                            },
                            {
                              label: "Cor",
                              value: data?.proprietarioAtual?.cor,
                            },
                            {
                              label: "Tempo de circulação",
                              value: data?.proprietarioAtual?.tempoCirculação,
                            },
                          ].map((item, idx) => (
                            <div
                              key={idx}
                              className="bg-gray-50 rounded-lg border border-gray-200 p-4 shadow-sm"
                            >
                              <p className="text-xs text-gray-500 font-medium uppercase mb-1">
                                {item.label}
                              </p>
                              <p className="text-base font-semibold text-gray-800">
                                {item.value || "Não informado"}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.historicoProprietarios && (
                  <div>
                    <TitleStripe>👥 Histórico de proprietários</TitleStripe>
                    {data?.historicoProprietarios?.statusRetorno == 1 ? (
                      <Timeline className="mt-10">
                        {data?.historicoProprietarios?.ocorrencias?.map(
                          (proprietario, index) => (
                            <Timeline.Item key={index} className="-mt-6">
                              <Timeline.Point />
                              <Timeline.Content>
                                <Timeline.Time>
                                  <div className="text-green-600">
                                    Data:{" "}
                                    {proprietario?.dataProcessamento ||
                                      "Não informado"}
                                  </div>
                                </Timeline.Time>
                                <Timeline.Title className="text-base">
                                  Nome: {proprietario?.nome || "Não informado"}
                                </Timeline.Title>
                                <Timeline.Body className="text-sm mt-2  ">
                                  <div className="grid grid-cols-3 gap-x-4 gap-y-2 bg-gray-100 rounded-md p-2 text-black">
                                    <div className="flex gap-2 items-center">
                                      <div className="font-semibold">
                                        Chassi:
                                      </div>
                                      <div>
                                        {proprietario?.chassi ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                      <div className="font-semibold">
                                        Renavam:
                                      </div>
                                      <div>
                                        {proprietario?.renavam ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                      <div className="font-semibold">
                                        Município:
                                      </div>
                                      <div>
                                        {proprietario?.municipio ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                      <div className="font-semibold">UF:</div>
                                      <div>
                                        {proprietario?.uf || "Não informado"}
                                      </div>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                      <div className="font-semibold">
                                        Documento:
                                      </div>
                                      <div>
                                        {proprietario?.documento ||
                                          "Não informado"}
                                      </div>
                                    </div>
                                  </div>
                                </Timeline.Body>
                              </Timeline.Content>
                            </Timeline.Item>
                          )
                        )}
                      </Timeline>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.fichaTecnica && (
                  <div>
                    <TitleStripe>📋 Ficha Técnica </TitleStripe>
                    {data?.fichaTecnica?.statusRetorno == 1 ? (
                      <>
                        {" "}
                        <div className="mt-4">
                          <div className="title-vehicle">
                            Informações técnicas
                          </div>
                          <div className="flex gap-12 mt-3 rounded bg-gray-100 p-2 mb-3">
                            <div className="text-sm min-w-72">
                              <div className="mb-3">
                                <span className="font-semibold">Câmbio: </span>
                                {data?.fichaTecnica?.cambio || "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Direção: </span>
                                {data?.fichaTecnica?.direcao || "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Motor: </span>
                                {data?.fichaTecnica?.motor || "Indisponível"}
                              </div>
                              <div>
                                <span className="font-semibold">
                                  Quantidade Passageiros:{" "}
                                </span>
                                {data?.fichaTecnica?.quantidadePassageiros ||
                                  "Indisponível"}
                              </div>
                            </div>
                            <div className="text-sm">
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Quantidade Portas:{" "}
                                </span>
                                {data?.fichaTecnica?.quantidadePortas ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Suspensão Dianteira:{" "}
                                </span>
                                {data?.fichaTecnica?.suspensaoDianteira ||
                                  "Indisponível"}
                              </div>
                              <div>
                                <span className="font-semibold">
                                  Suspensão Traseira:{" "}
                                </span>
                                {data?.fichaTecnica?.suspensaoTraseira ||
                                  "Indisponível"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="title-vehicle">Medidas</div>
                          <div className="flex gap-12 mt-3 rounded bg-gray-100 p-2 mb-3">
                            <div className="text-sm min-w-72">
                              <div className="mb-3">
                                <span className="font-semibold">Altura: </span>
                                {data?.fichaTecnica?.medidas?.altura ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Comprimento:{" "}
                                </span>
                                {data?.fichaTecnica?.medidas?.comprimento ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Largura: </span>
                                {data?.fichaTecnica?.medidas?.largura ||
                                  "Indisponível"}
                              </div>
                              <div>
                                <span className="font-semibold">
                                  Entre Eixos:{" "}
                                </span>
                                {data?.fichaTecnica.medidas?.entreEixos ||
                                  "Indisponível"}
                              </div>
                            </div>
                            <div className="text-sm">
                              <div className="mb-3">
                                <span className="font-semibold">Peso: </span>
                                {data?.fichaTecnica?.medidas?.peso ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Porta Malas:{" "}
                                </span>
                                {data?.fichaTecnica.medidas?.portaMalas ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Tanque: </span>
                                {data?.fichaTecnica?.medidas
                                  ?.tanqueCombustivel || "Indisponível"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="title-vehicle mb-3">
                            Medição Combustível
                          </div>
                          {data?.fichaTecnica?.medicaoCombustivel?.length >
                          0 ? (
                            <Table className="text-sm" striped>
                              <Table.Head>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Combustível
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Potência
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Clindr.
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Vel. Max.
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Torque
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Cons. Cidade
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 p-1">
                                  Cons. Estrada
                                </Table.HeadCell>
                              </Table.Head>
                              <Table.Body className="divide-y">
                                {data?.fichaTecnica?.medicaoCombustivel?.map(
                                  (medicao, index) => (
                                    <Table.Row
                                      key={index}
                                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                    >
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.combustivel ||
                                          "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.potencia || "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.cilindradas ||
                                          "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.velocidadeMaxima ||
                                          "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.torque || "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.consumoCidade ||
                                          "Sem informação"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center p-1">
                                        {medicao.consumoEstrada ||
                                          "Sem informação"}
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                                )}
                              </Table.Body>
                            </Table>
                          ) : (
                            <Alert
                              withBorderAccent
                              color="gray"
                              className="mt-4"
                            >
                              Sem informações da medição
                            </Alert>
                          )}
                        </div>
                        <div className="title-vehicle mt-4">Equipamentos</div>
                        {data?.fichaTecnica?.equipamentos?.length > 0 ? (
                          <>
                            <div className="container-alerts three-columns mt-4">
                              {data?.fichaTecnica?.equipamentos?.length > 0 &&
                                data?.fichaTecnica?.equipamentos?.map(
                                  (equipamento, index) => (
                                    <div
                                      className={`rounded px-2 py-3 flex items-center text-sm justify-center gap-2 text-center text-xs font-semibold capitalize border border-gray-300 ${
                                        equipamento?.disponibilidade?.toUpperCase() ===
                                        "DISPONIVEL"
                                          ? "text-green-500"
                                          : equipamento?.disponibilidade?.toUpperCase() ===
                                            "OPCIONAL"
                                          ? "text-blue-500"
                                          : "text-red-500"
                                      }`}
                                      key={index}
                                    >
                                      {equipamento?.disponibilidade?.toUpperCase() ===
                                      "DISPONIVEL" ? (
                                        <IoMdCheckmarkCircleOutline
                                          className="text-green-500"
                                          fontSize={20}
                                        />
                                      ) : (
                                        <>
                                          {equipamento?.disponibilidade?.toUpperCase() ===
                                          "OPCIONAL" ? (
                                            <IoMdOptions
                                              className="text-blue-500"
                                              fontSize={20}
                                            />
                                          ) : (
                                            <IoMdCloseCircleOutline
                                              className="text-red-500"
                                              fontSize={20}
                                            />
                                          )}
                                        </>
                                      )}
                                      {equipamento.descricao?.toLowerCase()}
                                    </div>
                                  )
                                )}
                            </div>
                          </>
                        ) : (
                          <Alert withBorderAccent color="gray" className="mt-4">
                            Sem informação dos equipamentos
                          </Alert>
                        )}
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.checklist && (
                  <div>
                    {data?.checklist?.statusRetorno == 1 ? (
                      <Checklist data={data} />
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.laudoCsv?.recalls?.length > 0 && (
                  <div>
                    <TitleStripe>Recall II</TitleStripe>
                    <div className="flex flex-col gap-2 mt-4">
                      {data?.laudoCsv?.recalls?.length === 0 ? (
                        <NoOcurrence />
                      ) : (
                        <>
                          {data?.laudoCsv?.recalls?.map((recall, idx) => (
                            <div
                              className="bg-red-100 p-2 flex flex-col gap-2 text-sm"
                              key={idx}
                            >
                              <div>
                                <span className="font-semibold inline-block mr-2">
                                  Nome:
                                </span>
                                {recall?.nomeRecall}
                              </div>
                              <div>
                                <span className="font-semibold inline-block mr-2">
                                  Descrição:
                                </span>
                                {recall?.descricaoRecall}
                              </div>
                              <div>
                                <span className="font-semibold inline-block mr-2">
                                  Data:
                                </span>
                                {recall?.dataRegistroFormatada}
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                )}

                {data?.laudoCsv?.renainfs?.length > 0 && (
                  <div>
                    <TitleStripe>Renainf II</TitleStripe>
                    <div>
                      {data?.laudoCsv?.renainfs?.map((renainf, index) => (
                        <div key={index}>
                          <div className="bg-gray-200 p-2 mt-3 font-semibold text-red-800">
                            Renainf - Infração/
                            {renainf?.detalheNumAutoInfracao || "Não informado"}
                          </div>
                          <div className="bg-red-100 p-2 grid-cols-2 grid gap-2 text-sm">
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Auto de infração:
                              </div>
                              <div>
                                {renainf?.detalheNumAutoInfracao ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Limite permitido:
                              </div>
                              <div>
                                {renainf?.detalheLimitePermitido ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Data de infração:
                              </div>
                              <div>
                                {moment(renainf?.detalheDtInfracao)?.format(
                                  "DD/MM/yyyy"
                                ) || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Local infração:
                              </div>
                              <div>
                                {renainf?.detalheLocalInfracao ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Exigibilidade:
                              </div>
                              <div>
                                {renainf?.exigibilidade || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">Marca/Modelo:</div>
                              <div>
                                {renainf?.detalheMarcaModelo || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">Infração:</div>
                              <div>{renainf?.infracao || "Não informado"}</div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Medição considerada:
                              </div>
                              <div>
                                {renainf?.detalheMedicaoConsiderada ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Órgão autuador:
                              </div>
                              <div>
                                {renainf?.detalheOrgaoAutuador ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">Medição real:</div>
                              <div>
                                {renainf?.detalheMedicaoReal || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Cadastro infração:
                              </div>
                              <div>
                                {renainf?.detalheCadastramentoInfracao ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Cod. Infração:
                              </div>
                              <div>
                                {renainf?.detalheCodInfracao || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Cod. Município emplacamento:
                              </div>
                              <div>
                                {renainf?.detalheCodMunInfracao ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">Placa:</div>
                              <div>{renainf?.detalhePlaca}</div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Data Emissão penalidade:
                              </div>
                              <div>
                                {moment(
                                  renainf?.detalheDtEmissaoPenalidade
                                )?.format("DD/MM/yyyy") || "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Valor da infração:
                              </div>
                              <div>
                                {formatToReal(renainf?.detalheValorInfracao) ||
                                  "Não informado"}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">
                                Data/Hora da infração:
                              </div>
                              <div>
                                {moment(renainf?.detalheDtInfracao)?.format(
                                  "DD/MM/yyyy"
                                )}{" "}
                                | {renainf?.detalheHrInfracao}
                              </div>
                            </div>
                            <div className="flex items-start gap-2">
                              <div className="font-semibold">Valor pago:</div>
                              <div>
                                {renainf?.dadosPagamentoValorPago ||
                                  "Não informado"}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {data?.laudoCsv && data?.laudoCsv?.renajuds?.length > 0 && (
                  <div>
                    <TitleStripe>Renajud II </TitleStripe>
                    <div>
                      {data?.laudoCsv?.renajuds?.map((renajud, index) => (
                        <div
                          key={index}
                          className="bg-red-100 p-2 grid-cols-2 grid gap-2 mt-2 text-sm"
                        >
                          <div>
                            <div className="font-semibold">
                              Órgão Judiciário
                            </div>
                            <div>
                              {renajud?.nomeOrgaoJudicial || "Não informado"}
                            </div>
                          </div>
                          <div>
                            <div className="font-semibold">Restrições</div>
                            <div>
                              {renajud?.tipoRestricaoJudicial ||
                                "Não informado"}
                            </div>
                          </div>
                          <div>
                            <div className="font-semibold">Processo</div>
                            <div>
                              {renajud?.numeroDoProcesso || "Não informado"}
                            </div>
                          </div>
                          <div>
                            <div className="font-semibold">Tribunal</div>
                            <div>
                              {renajud?.codigoTribunal || "Não informado"}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {data?.laudoCsv && (
                  <div>
                    <TitleStripe className="mb-5">Laudo csv</TitleStripe>
                    {data?.laudoCsv?.statusRetorno == 1 ? (
                      <div>
                        {data?.laudoCsv?.ocorrencias?.length > 0 ? (
                          <>
                            {data?.laudoCsv?.ocorrencias?.map((laudo, idx) => (
                              <PdfViewer
                                key={idx}
                                url={laudo.identificadorCsv}
                              />
                            ))}
                          </>
                        ) : (
                          <NoOcurrence />
                        )}
                      </div>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-4">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.codigoSegurancaCRV && <CodigoSegurancaCRV data={data} />}

                {data?.localizacao && (
                  <div>
                    <TitleStripe>Dados Cadastrais</TitleStripe>
                    {data?.localizacao?.statusRetorno == 1 ? (
                      <>
                        {data?.localizacao?.dadosCadastrais && (
                          <div className="flex gap-16 mt-4">
                            <div className="text-base flex-1">
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nome completo:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastrais?.nome}
                              </div>

                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nome da mãe:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastrais?.nomeMae ||
                                  "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Data de nascimento:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastrais
                                  ?.dataNascimento || "Indisponível"}
                              </div>
                            </div>
                            <div className="text-base flex-1">
                              <div className="mb-3">
                                <span className="font-semibold">CPF: </span>
                                {data?.localizacao?.dadosCadastrais?.cpf
                                  ? formatDocument(
                                      data?.localizacao?.dadosCadastrais?.cpf
                                    )
                                  : "Não informado"}
                              </div>
                              <div className="mb-3 flex gap-2">
                                <span className="font-semibold">
                                  Situação:{" "}
                                </span>
                                <div
                                  className={`${
                                    data?.localizacao?.dadosCadastrais?.situacao?.toUpperCase() ===
                                    "REGULAR"
                                      ? "bg-primary"
                                      : "bg-red-500"
                                  } px-2 rounded-md text-white font-semibold`}
                                >
                                  {data?.localizacao?.dadosCadastrais
                                    ?.situacao || "Indisponível"}
                                </div>
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">Sexo: </span>
                                {(data?.localizacao?.dadosCadastrais?.sexo ===
                                "M"
                                  ? "Masculino"
                                  : "Feminino") || "Indisponível"}
                              </div>
                            </div>
                          </div>
                        )}

                        {data?.localizacao?.dadosCadastraisPJ && (
                          <div className="grid grid-cols-2 mt-4 text-sm">
                            <div className="text-base flex-1">
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Razão Social:{" "}
                                </span>
                                {
                                  data?.localizacao?.dadosCadastraisPJ
                                    ?.razaoSocial
                                }
                              </div>

                              <div className="mb-3">
                                <span className="font-semibold">
                                  Nome Fantasia:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastraisPJ
                                  ?.nomeFantasia || "Indisponível"}
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Data de fundação:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastraisPJ
                                  ?.dataFundacao || "Indisponível"}
                              </div>
                            </div>
                            <div className="text-base flex-1">
                              <div className="mb-3">
                                <span className="font-semibold">CNPJ: </span>
                                {data?.localizacao?.dadosCadastraisPJ?.cnpj}
                              </div>
                              <div className="mb-3 flex gap-2">
                                <span className="font-semibold">
                                  Situação:{" "}
                                </span>
                                <div className={`font-semibold`}>
                                  {data?.localizacao?.dadosCadastraisPJ
                                    ?.situacao || "Indisponível"}
                                </div>
                              </div>
                              <div className="mb-3">
                                <span className="font-semibold">
                                  Ramo de atividade:{" "}
                                </span>
                                {data?.localizacao?.dadosCadastraisPJ
                                  ?.ramoAtividade || "Indisponível"}
                              </div>
                            </div>
                          </div>
                        )}

                        {data?.localizacao?.enderecos && (
                          <div className="mt-4">
                            <TitleStripe>Endereços</TitleStripe>
                            {data?.localizacao?.enderecos?.length > 0 ? (
                              <Enderecos
                                enderecos={data?.localizacao?.enderecos}
                              />
                            ) : (
                              <NoOcurrence />
                            )}
                          </div>
                        )}

                        <div className="mt-4">
                          <TitleStripe>E-mails</TitleStripe>
                          {data?.localizacao?.emails?.length > 0 ? (
                            <Emails emails={data?.localizacao?.emails} />
                          ) : (
                            <NoOcurrence />
                          )}
                        </div>

                        <div className="mt-4">
                          <TitleStripe>Telefones fixos</TitleStripe>
                          {data?.localizacao?.telefones?.length > 0 ? (
                            <Telefones
                              telefones={data?.localizacao?.telefones}
                            />
                          ) : (
                            <NoOcurrence />
                          )}
                        </div>

                        <div className="mt-4">
                          <TitleStripe>Telefones móveis</TitleStripe>
                          {data?.localizacao?.celulares?.length > 0 ? (
                            <Telefones
                              telefones={data?.localizacao?.celulares}
                            />
                          ) : (
                            <NoOcurrence />
                          )}
                        </div>
                      </>
                    ) : (
                      <Alert withBorderAccent color="gray" className="mt-5">
                        Consulta Indisponível no momento
                      </Alert>
                    )}
                  </div>
                )}

                {data?.cndt && <CNDT data={data} />}

                {data?.crlv && <CRLV data={data} />}

                <FooterLGPD />

                <FooterQuery hasHeader={hasHeaderPDF} />
              </Card>
            </>
          ) : (
            <Card>
              <div
                className="flex justify-center items-center flex-col gap-2"
                style={{ height: "500px" }}
              >
                <DotLottieReact
                  src="https://lottie.host/09025d6a-2bad-4558-9575-2c76eb19bd11/pUglw2jFxF.lottie"
                  loop
                  autoplay
                  style={{ width: "220px", height: "100px" }}
                />
                <div className="font-semibold text-green-800">
                  Carregando informações da consulta...
                </div>
              </div>
            </Card>
          )}
        </div>
      </>
    </>
  );
};

export default CustomVehicleQueryReview;
